import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpInterceptorFn,
  HttpHandlerFn,
} from '@angular/common/http';
import { switchMap, take } from 'rxjs';
import { Auth, idToken } from '@angular/fire/auth';

export const firebaseTokenInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const auth = inject(Auth);
  return idToken(auth).pipe(
    // Take 1 because when user logs out, we don't want to issue another request
    take(1),
    switchMap((token: string | null) => {
      if (request.method !== 'JSONP' && token) {
        request = request.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
      }
      return next(request);
    })
  );
};
